import i18n from '../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";

export default class QuantityConfirmationModel extends BaseModel {
  quantity = null;
  available_quantity = null;

  rules = {
    quantity: `required|max_value:${this.available_quantity}`
  };

  attributeLabels = {
    quantity: i18n.t('Quantity'),
  };

  customMessages = {
    "quantity": {
      max_value: function (name, rule) {
        return i18n.t('This value cannot exceed the available quantity of {val}', {val: rule.max})
      },
    }
  }
  attributeHints = {};

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
